// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","promoCode":"promoCode-2b03T"};